export default "__VITE_ASSET__BubeFium__"